import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/api/query-keys";
import { getMe } from "../api/getMe";

/**
 * The current user. Mounted only behind the auth guard, so a fetch here always
 * carries a bearer token. Drives the sidebar account footer + Settings → Account.
 */
export function useMe() {
  return useQuery({
    queryKey: queryKeys.me.detail(),
    queryFn: getMe,
    staleTime: 5 * 60_000,
  });
}
